export default "__VITE_ASSET__rR3iYe74__"